import {
  SchemaDefinition,
  SchemaTransformError,
  UnknownSchema,
  ViewModel
} from '@rehaje/core'

import type { VariableSpecific } from './TypedNode'

export interface SchemaVariableSpecific extends RehajeSchemaMetadata {
  /**
   * Variable 默认配置
   */
  default?: VariableSpecific
  type: 'Schema.Variable'
  /**
   * 值
   */
  value?: any
}

export class SchemaVariableDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaVariableSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaVariableSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaVariableSpecific
  ): SchemaVariableSpecific {
    return { ...this.inferOnlySchema(schema), value: target }
  }

  override inferOnlySchema(schema: SchemaVariableSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaVariableSpecific): string {
    if (schema.value instanceof ViewModel)
      return super.inferShapeTypeScript(schema.value)
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaVariableSpecific,
    path: PropertyKey[] = []
  ) {
    if (this.test(target, schema, path)) return target
    if (target !== schema.fallback)
      this.raise(new SchemaTransformError(schema.name))
    return target
  }

  override validate(target: any, schema: SchemaVariableSpecific) {
    this.validateMetadata(target, schema, (target) => {
      return typeof target === 'function' || this.isRelationSpecific(target)
    })
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.Variable': SchemaVariableSpecific
  }
}
